// Judge.me Carousel - CSS Marquee Mode + Skeleton Loading (v6)
(function() {
  'use strict';

  var skeletonTimer = null;
  var skeletonStart = null;

  // Wait for DOM then start
  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  // Show skeleton placeholder while Judge.me loads, then init carousel
  function showSkeleton() {
    var section = document.getElementById('shopify-section-1725331094ff02280c');
    if (section && !section.querySelector('.jdgm-carousel-wrapper') && !section.querySelector('.jdgm-skeleton')) {
      section.classList.add('jdgm-reviews-section');
      var sk = document.createElement('div');
      sk.className = 'jdgm-skeleton';
      sk.innerHTML = '<div class="jdgm-skeleton-header"></div><div class="jdgm-skeleton-track"><div class="jdgm-skeleton-card"></div><div class="jdgm-skeleton-card"></div><div class="jdgm-skeleton-card"></div><div class="jdgm-skeleton-card"></div></div>';
      section.insertBefore(sk, section.firstChild);
    }
    skeletonStart = Date.now();

    // Keep checking for wrapper
    skeletonTimer = setInterval(function() {
      var w = document.querySelector('.jdgm-carousel__item-wrapper');
      if (w) {
        clearInterval(skeletonTimer);
        var elapsed = Date.now() - skeletonStart;
        var delay = Math.max(0, 1500 - elapsed);
        setTimeout(function() { initCarousel(w); }, delay);
      }
    }, 300);
  }

  function removeSkeleton() {
    if (skeletonTimer) { clearInterval(skeletonTimer); skeletonTimer = null; }
    var sk = document.querySelector('.jdgm-skeleton');
    if (sk && sk.parentNode) sk.parentNode.removeChild(sk);
  }

  function initCarousel(wrapper) {
    removeSkeleton();

    // Force all-reviews-text visible (override Judge.me inline !important)
    var art = document.querySelector('.jdgm-all-reviews-text');
    if (art) {
      art.style.setProperty('display', 'block', 'important');
    }
    // Also clean Judge.me injected style tag that hides it
    document.querySelectorAll('style').forEach(function(s) {
      if (s.textContent && s.textContent.indexOf('all-reviews-text') > -1 && s.textContent.indexOf('display:none') > -1) {
        s.textContent = s.textContent.replace(/\.jdgm-all-reviews-text[^}]*display:\s*none[^}]*}/g, '');
      }
    });

    // Add class to parent section
    var cw = document.querySelector('.jdgm-carousel-wrapper');
    if (cw) {
      var sec = cw.closest('[class*="shopify-section"]');
      if (sec) sec.classList.add('jdgm-reviews-section');
    }

    // Avatar initials
    document.querySelectorAll('.jdgm-carousel-item__reviewer-name').forEach(function(el) {
      var name = (el.textContent || '').trim();
      el.setAttribute('data-initial', name.charAt(0) || '?');
    });

    // Force review body visible
    document.querySelectorAll('.jdgm-carousel-item__review-body').forEach(function(el) {
      el.style.setProperty('display', 'block', 'important');
    });
    document.querySelectorAll('.jdgm-carousel-item__review-body p').forEach(function(el) {
      el.style.setProperty('display', 'block', 'important');
    });

    // Clone items for seamless marquee
    wrapper.querySelectorAll('.jdgm-carousel-item').forEach(function(item) {
      wrapper.appendChild(item.cloneNode(true));
    });

    // Watch for new items
    var obs = new MutationObserver(function() {
      document.querySelectorAll('.jdgm-carousel-item__review-body').forEach(function(el) {
        if (el.style.display === 'none') el.style.setProperty('display', 'block', 'important');
      });
    });
    var container = document.querySelector('.jdgm-carousel__item-container') || document.querySelector('.jdgm-carousel');
    if (container) obs.observe(container, { childList: true, subtree: true });

    // Prevent Judge.me inline transform
    function clearTransform() {
      if (wrapper.style.transform) wrapper.style.transform = '';
      if (wrapper.style.transition) wrapper.style.transition = '';
    }
    var styleObs = new MutationObserver(function(muts) {
      muts.forEach(function(m) {
        if (m.type === 'attributes' && m.attributeName === 'style') clearTransform();
      });
    });
    styleObs.observe(wrapper, { attributes: true, attributeFilter: ['style'] });
    clearTransform();
    // Also keep all-reviews-text visible every 2s
    function forceReviewTextVisible() {
      var art2 = document.querySelector('.jdgm-all-reviews-text');
      if (art2 && window.getComputedStyle(art2).display === 'none') {
        art2.style.setProperty('display', 'block', 'important');
      }
    }
    var ti = setInterval(function() { clearTransform(); forceReviewTextVisible(); }, 2000);

    // Pause on hover/touch
    if (cw) {
      cw.addEventListener('mouseenter', function() { wrapper.style.animationPlayState = 'paused'; });
      cw.addEventListener('mouseleave', function() { wrapper.style.animationPlayState = 'running'; });
      cw.addEventListener('touchstart', function() { wrapper.style.animationPlayState = 'paused'; });
      cw.addEventListener('touchend', function() { wrapper.style.animationPlayState = 'running'; });
    }
  }

  ready(showSkeleton);
})();
